import React from 'react';
import './GoogleReviewSnippet.css';
import { FaStar, FaGoogle } from 'react-icons/fa';

const GoogleReviewSnippet = () => {
  return (
    <div className="google-review-snippet" data-aos="fade-up">
      <div className="review-card">
        <div className="review-icon">
          <FaGoogle />
        </div>
        <div className="review-content">
          <p className="review-text">Excellent</p>
          <div className="stars">
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
            <FaStar />
          </div>
          <p className="rating-info">
            <strong>4.9/5</strong> based on 300+ Google Reviews
          </p>
          <a href="https://g.page/r/RAD-EnviroNex-Madurai" className="gmb-link" target="_blank" rel="noopener noreferrer">
            View on Google
          </a>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewSnippet;
